export const getActions = (item) => {
    return {
        actions: [
            {
                label: 'Ver detalles',
                icon: 'details',
                action: 'details'
            },
            {
                label: 'Asignar venta',
                icon: 'pay',
                action: 'assign'
            },
            {
                label: 'Administrar imágenes',
                icon: 'image',
                action: 'images'
            },
            ...(item?.active && !item?.en_incidencia ? [{
                label: 'Derivar a Incidencia',
                icon: 'issue',
                action: 'incidencia'
            }] : []),
            ...(item?.active && item?.en_incidencia ? [{
                label: 'Derivar a En Curso',
                icon: 'status',
                action: 'en-curso'
            }] : []),
            (item?.active) ?
            {
                label: 'Finalizar',
                icon: 'disable',
                action: 'disable'
            } 
            : 
            {
                label: 'Reactivar',
                icon: 'enable',
                action: 'enable'
            },
            {
                label: 'Eliminar',
                icon: 'delete',
                action: 'delete'
            },
        ],
        extra: []
    }
}